var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#9EC5FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4204_51009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5C12.3978 18.5 12.7794 18.342 13.0607 18.0607C13.342 17.7794 13.5 17.3979 13.5 17H10.5C10.5 17.3979 10.658 17.7794 10.9393 18.0607C11.2206 18.342 11.6022 18.5 12 18.5ZM12 7.93855L11.4023 8.0593C10.7242 8.19745 10.1147 8.56562 9.67699 9.10151C9.23923 9.6374 9.00007 10.3081 9 11C9 11.471 8.8995 12.6478 8.65575 13.8065C8.53575 14.3818 8.37375 14.981 8.1585 15.5H15.8415C15.6263 14.981 15.465 14.3825 15.3442 13.8065C15.1005 12.6478 15 11.471 15 11C14.9998 10.3082 14.7605 9.63771 14.3228 9.10197C13.885 8.56624 13.2757 8.19817 12.5977 8.06005L12 7.9378V7.93855ZM16.665 15.5C16.8323 15.8353 17.0258 16.1008 17.25 16.25H6.75C6.97425 16.1008 7.16775 15.8353 7.335 15.5C8.01 14.15 8.25 11.66 8.25 11C8.25 9.18505 9.54 7.67005 11.2537 7.3243C11.2433 7.22001 11.2548 7.11469 11.2875 7.01513C11.3203 6.91556 11.3735 6.82396 11.4438 6.74624C11.5141 6.66852 11.6 6.60639 11.6957 6.56387C11.7915 6.52136 11.8952 6.49939 12 6.49939C12.1048 6.49939 12.2085 6.52136 12.3043 6.56387C12.4 6.60639 12.4859 6.66852 12.5562 6.74624C12.6265 6.82396 12.6797 6.91556 12.7125 7.01513C12.7452 7.11469 12.7567 7.22001 12.7463 7.3243C13.594 7.49672 14.356 7.95682 14.9034 8.62667C15.4508 9.29653 15.7499 10.135 15.75 11C15.75 11.66 15.99 14.15 16.665 15.5Z",
    fill: "#0061F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4204_51009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification_icon.49c32716d986f645bc9715d8613dfe16.svg";
export { ForwardRef as ReactComponent };